/** Helpers de unidade de medida — saldo sempre na base; operacional é exibição/digitação. */

export const SUGESTAO_UM_CATEGORIA = {
  Piscina: { basePreferida: "KG", operacional: "GR" },
  Limpeza: { basePreferida: "L", operacional: "ML" },
  Manutencao: { operacional: null },
  Eletrica: { operacional: null },
  EPI: { operacional: null },
  Escritorio: { operacional: null },
  Outro: { operacional: null },
};

export const itemIdUmBase = (row) => row?.idUnidadeBase || row?.idunidadebase || "";
export const itemIdUmOp = (row) => row?.idUnidadeOperacional || row?.idunidadeoperacional || "";
export const itemIdUmCompra = (row) => row?.idUnidadeCompra || row?.idunidadecompra || "";
export const itemSiglaBase = (row) =>
  row?.siglaUnidadeBase || row?.siglaunidadebase || row?.unidadeMedida || row?.unidademedida || "";

export const unidadesBase = (lista) => (lista || []).filter((u) => u.ehBase && u.ativo !== 0);

export const unidadesOperacionais = (lista, idBase) => {
  if (!idBase) return lista || [];
  return (lista || []).filter(
    (u) => u.ativo !== 0 && (String(u.idUnidadeBase) === String(idBase) || String(u.id) === String(idBase))
  );
};

export const calcQtdBase = (qtd, um) => {
  if (!um || qtd === "" || qtd == null) return null;
  const n = parseFloat(qtd);
  if (!Number.isFinite(n)) return null;
  return n * (um.fatorParaBase || 1);
};

/** Converte quantidade da base para a UM operacional (ex.: 1,5 L → 1500 ML). */
export const calcQtdOperacional = (qtdBase, umOp) => {
  if (qtdBase == null || qtdBase === "") return null;
  const n = parseFloat(qtdBase);
  if (!Number.isFinite(n)) return null;
  if (!umOp || umOp.ehBase) return n;
  const fator = umOp.fatorParaBase || 1;
  if (!fator) return null;
  return n / fator;
};

export const buscarUm = (unidades, id) =>
  (unidades || []).find((u) => String(u.id) === String(id));

export const aplicarSugestaoCategoria = (categoria, unidades, form, { somenteSeVazio = true } = {}) => {
  const sug = SUGESTAO_UM_CATEGORIA[categoria];
  if (!sug) return {};
  const updates = {};
  const podeBase = !somenteSeVazio || !form.idUnidadeBase;
  const podeOp = !somenteSeVazio || !form.idUnidadeOperacional;

  if (sug.basePreferida && podeBase) {
    const ub = unidades.find((u) => u.sigla === sug.basePreferida && u.ehBase);
    if (ub) updates.idUnidadeBase = String(ub.id);
  }
  const idBase = updates.idUnidadeBase || form.idUnidadeBase;
  if (sug.operacional && idBase && podeOp) {
    const uo = unidades.find(
      (u) => u.sigla === sug.operacional && String(u.idUnidadeBase) === String(idBase)
    );
    if (uo) updates.idUnidadeOperacional = String(uo.id);
  }
  return updates;
};

const fmtN = (v, dec = 3) =>
  Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: dec });

/**
 * Texto de saldo duplo: "7,5 KG" ou "7,5 KG (7.500 GR)".
 * qtdBase: saldo em unidade base do item.
 */
export function fmtSaldoDuplo(qtdBase, unidades, idUmBase, idUmOp, dec = 3) {
  const umBase = buscarUm(unidades, idUmBase);
  const umOp = buscarUm(unidades, idUmOp);
  const siglaB = umBase?.sigla || "base";
  const baseTxt = `${fmtN(qtdBase, dec)} ${siglaB}`;

  if (!umOp || umOp.ehBase || String(umOp.id) === String(idUmBase)) {
    return baseTxt;
  }
  const qOp = calcQtdOperacional(qtdBase, umOp);
  if (qOp == null) return baseTxt;
  const decOp = umOp.fatorParaBase < 0.01 ? 0 : dec;
  return `${baseTxt} (${fmtN(qOp, decOp)} ${umOp.sigla})`;
}
